<template>
  <div>
    <div class="container">
      <div style="flex:1">
        <h3 style="margin-bottom:16px">{{ editType === 'sheet' ? 'QA Sheet' : '개선사항' }} 등록</h3>
        <div class="flex-align">
          <div>
            <div class="label">디바이스</div>
            <select v-model="device">
              <option value="pc">PC</option>
              <option value="mobile">모바일</option>
              <option value="common">공통</option>
            </select>
          </div>
          <div>
            <div class="label">구분</div>
            <select v-model="ftype">
              <option v-for="(item,idx) in fTypeOptions" :key="'ftype-'+idx" :value="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div>
            <div class="label">기능 대분류</div>
            <select v-model="f1">
              <option v-for="(item,idx) in qaList" :key="'qa-'+idx" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div>
            <div class="label">위치</div>
            <select v-model="qaLocation">
              <option value="front">프론트</option>
              <option value="admin">백오피스</option>
              <option value="builder">빌더</option>
            </select>
          </div>
        </div>

        <template v-if="qaLocation==='front'">
          <div class="flex-align" style="margin-top: 12px">
            <div>
              <div class="label">플로우 뷰</div>
              <select v-model="qa.front_feature_id">
                <option v-for="(item,idx) in front.feature" :key="'front-feature-'+idx"
                        :value="item.id">{{ item.name }}
                </option>
              </select>
            </div>
            <div v-if="qa.front_feature_id>0">
              <div class="label">노출경로</div>
              <select v-model="qa.front_location_id">
                <option v-for="(item,idx) in front.location" :key="'front-feature-'+idx"
                        :value="item.id">{{ item.name }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="qa.front_location_id>0" style="margin-top: 12px">
            <div class="label">UI/액션</div>
            <select v-model="qa.front_action_id" style="width:100%">
              <option v-for="(item,idx) in front.action" :key="'front-feature-'+idx"
                      :value="item.id">[{{ item.name }}] {{ item.result }}</option>
            </select>
          </div>
        </template>

        <div v-if="qaLocation==='admin'">
          <div style="margin-top: 12px">
            <div class="label">위치</div>
            <select v-model="qa.admin_location_id">
              <option v-for="(item,idx) in admin.location" :key="'admin-location-'+idx"
                      :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
          <div style="margin-top: 12px">
            <div class="label">기능</div>
            <select v-model="qa.admin_feature_id" style="width:100%">
              <option v-for="(item,idx) in admin.feature" :key="'admin-location-'+idx"
                      :value="item.id">[{{ item.content }}] {{ item.result }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="qaLocation==='builder'">
          <div style="margin-top: 12px">
            <div class="label">위치</div>
            <select v-model="qa.builder_location_id">
              <option v-for="(item,idx) in builder.location" :key="'builder-location-'+idx"
                      :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
          <div style="margin-top: 12px">
            <div class="label">기능</div>
            <select v-model="qa.builder_feature_id" style="width:100%">
              <option v-for="(item,idx) in builder.feature" :key="'builder-location-'+idx"
                      :value="item.id">[{{ item.content }}] {{ item.result }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="editType === 'sheet'" style="margin-top: 12px" class="flex-align">
          <div>
            <div class="label">담당자 지정</div>
            <select v-model="qa.task_user_id">
              <option value="" v-for="(user,idx) in userList" :value="user.id" :key="`user-${idx}`">{{ user.name }}</option>
            </select>
          </div>
          <div>
            <div class="label">우선순위</div>
            <input type="number" v-model.number="qa.priority">
          </div>
        </div>


      </div>
      <textarea rows="5" v-model="qa.req_content" :placeholder="`${editType === 'sheet' ? '요청' : '제안'}할 내용을 입력하세요`"></textarea>
      <div class="flex-end" style="margin-top:12px">
        <button class="button is-primary" @click="save">등록하기</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "QaEditModal",
    props: {
      pdevice: {
        type: String,
        default: 'pc'
      },
      pftype: {
        type: String,
        default: 'common'
      },
      feature: {
        type: Number,
        default: 1
      },
      editType: {
        type: String,
        default: 'sheet'
      }
    },
    created() {
      this.f1 = this.feature;
      this.device = this.pdevice;
      this.ftype = this.pftype;
      this.url = `admin/launchpack/qa/${this.f1}`;
      this.getQaList();
      this.getUserList();
      this.getFrontFeature();
    },
    watch: {
      feature(n) {
        this.f1 = n;
      },
      pdevice(n) {
        this.device = n;
      },
      pftype(n) {
        this.ftype = n;
      },
      device() {
        this.getQaList();
      },
      ftype() {
        this.getQaList();
      },
      f1() {
        this.url = `admin/launchpack/qa/${this.f1}`;
        this.getQaList();
      },
      qaLocation(n) {
        this.init();
        if (n === 'front') {
          this.getFrontFeature();
        } else if(n === 'admin') {
          this.getAdminLocation();
        } else if(n === 'builder') {
          this.getBuilderLocation();
        }
      },
      'qa.front_feature_id'(n) {
        if(n!==0) {
          this.getFrontLocation();
        }
      },
      'qa.front_location_id'(n) {
        if(n!==0) {
          this.getFrontAction();
        }
      },
      'qa.admin_location_id'(n) {
        if(n!==0) {
          this.getAdminFeature();
        }
      },
      'qa.builder_location_id'(n) {
        if(n!==0) {
          this.getBuilderFeature();
        }
      }
    },
    data() {
      return {
        url: 'admin/launchpack/qa',
        qaLocation: 'front',
        userList: [],
        front: {
          feature: [],
          location: [],
          action: []
        },
        admin: {
          location: [],
          feature: [],
        },
        builder: {
          location: [],
          feature: [],
        },
        qa: {
          front_feature_id: 0,
          front_location_id: 0,
          front_action_id: 0,
          admin_location_id: 0,
          admin_feature_id: 0,
          builder_location_id: 0,
          builder_feature_id: 0,
          task_user_id: 0,
          req_content: '',
          priority: 1
        },
        device: 'pc',
        ftype: 'common',
        f1: '',
        fTypeOptions: [
          {
            label: '공통',
            value: 'common'
          },
          {
            label: '기본',
            value: 'basic'
          },
          {
            label: '디자인',
            value: 'design'
          },
          {
            label: '팩',
            value: 'pack'
          },
          {
            label: '자동설치 플러그인',
            value: 'auto_plugin'
          },
          {
            label: '수동설치 플러그인',
            value: 'passive_plugin'
          },
          {
            label: '템플릿',
            value: 'template'
          }
        ],
        qaList: []
      }
    },
    methods: {
      getQaList() {
        this.qaLocation = '';
        this.$axios.get(`admin/launchpack/qa?device=${this.device}&ftype=${this.ftype}`).then(res => {
          this.qaList = res.data;
        });
      },
      getUserList() {
        this.$axios.get('admin/member/admin').then(res=>{
          this.userList = res.data;
        });
      },
      init() {
        this.front = {
          feature: [],
          location: [],
          action: []
        };
        this.admin = {
          location: [],
          feature: [],
        };
        this.builder = {
          location: [],
          feature: [],
        };
        this.qa.front_feature_id = 0;
        this.qa.front_location_id = 0;
        this.qa.front_action_id = 0;
        this.qa.admin_location_id = 0;
        this.qa.admin_feature_id = 0;
        this.qa.builder_location_id = 0;
        this.qa.builder_feature_id = 0;
      },
      getFrontFeature() {
        this.$axios.get(`${this.url}/front_feature`).then(res => {
          this.front.feature = res.data;
          if(this.front.feature.length>0) {
            this.qa.front_feature_id = this.front.feature[0].id;
          }
        });
      },
      getFrontLocation() {
        this.$axios.get(`${this.url}/front_feature/${this.qa.front_feature_id}/location`).then(res => {
          this.front.location = res.data;
        });
      },
      getFrontAction() {
        this.$axios.get(`${this.url}/front_feature/${this.qa.front_feature_id}/location/${this.qa.front_location_id}/action`).then(res => {
          this.front.action = res.data;
        });
      },
      getAdminLocation() {
        this.$axios.get(`${this.url}/admin_location`).then(res => {
          this.admin.location = res.data;
        });
      },
      getAdminFeature() {
        this.$axios.get(`${this.url}/admin_location/${this.qa.admin_location_id}/feature`).then(res => {
          this.admin.feature = res.data;
        });
      },
      getBuilderLocation() {
        this.$axios.get(`${this.url}/builder_location`).then(res => {
          this.builder.location = res.data;
        });
      },
      getBuilderFeature() {
        this.$axios.get(`${this.url}/builder_location/${this.qa.builder_location_id}/feature`).then(res => {
          this.builder.feature = res.data;
        });
      },
      valid() {
        let result = true;
        if(this.qa.req_content === '') {
          this.toast(`${this.editType === 'sheet' ? '요청' : '제안'}할 내용을 입력해주세요.`);
          result = false;
        }
        else if(this.editType === 'sheet' && this.qa.task_user_id === 0) {
          this.toast('담당자를 지정해주세요.');
          result = false;
        }

        else if(this.qa.front_feature_id > 0) {
          if(this.qa.front_action_id === 0) {
            this.toast('프론트는 액션까지 선택해야 등록할 수 있습니다.');
            result = false;
          }
        }
        else if(this.qa.admin_location_id) {
          if(this.qa.admin_feature_id === 0) {
            this.toast('백오피스는 기능까지 선택해야 등록할 수 있습니다.');
          }
        }
        else if(this.qa.builder_location_id) {
          if(this.qa.builder_feature_id === 0) {
            this.toast('빌더는 기능까지 선택해야 등록할 수 있습니다.');
          }
        }
        else if(this.qa.front_action_id === 0 && this.qa.admin_feature_id === 0 && this.qa.builder_feature_id === 0) {
          this.toast('액션, 기능을 선택해주세요.')
          result = false;
        }

        return result;
      },
      save() {
        if(this.valid()) {
          let params = this.qa;
          Object.keys(params).forEach(key=>{
            if(key.indexOf('_id')>-1 && params[key] === 0) {
              delete params[key];
            }
          });
          this.$axios.post(`${this.url}/${this.editType}`, params).then(res=>{
            if(res.status === 200) {
              this.toast('등록되었습니다.');
              this.$emit('close');
            }
          }).catch(()=>{
            this.toast('등록에 실패했습니다.');
          });
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    height 500px
    padding 24px
    display flex
    flex-direction column

  input
  select
  textarea
    border 1px solid #dddddd
    padding 4px 8px
    border-radius 4px
    max-width 100%

  select
    margin-right 8px
  textarea
    margin-top 12px
    width 100%

  .label
    font-size 13px
    margin-bottom 4px
</style>
